import { render, staticRenderFns } from "./ScaleProductModal.vue?vue&type=template&id=12617a4d"
import script from "./ScaleProductModal.vue?vue&type=script&lang=js"
export * from "./ScaleProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports